import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { generatePath } from "react-router-dom";
import { z } from "zod";

const CREATE_SHARE_LINK_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/agentprofile/referral-links`;

const createReferralLinkResponseSchema = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      type: z.literal("referral-links"),
      attributes: z.object({
        referralLink: z.string(),
      }),
    })
  ),
});

export type CreateReferralLinkResponseType = z.infer<typeof createReferralLinkResponseSchema>;

export function useCreateShareLink(
  options?: UseMutationOptions<
    CreateReferralLinkResponseType,
    AxiosError<CreateReferralLinkResponseType>
  >
) {
  return useMutation({
    mutationFn: async () => {
      const response = await post({
        url: generatePath(CREATE_SHARE_LINK_URL),
        data: {},
        requestSchema: z.object({}),
        responseSchema: createReferralLinkResponseSchema,
      });

      return response.data;
    },

    ...options,
  });
}
